import React, { Component } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';
import close from '../../assets/img/icons/close.svg';
import axios from 'axios';
import ls from "local-storage";
import { Trans } from "react-i18next";
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Forgot extends Component {
    constructor(props) {
        super(props);
        this.onChangeForgotemail = this.onChangeForgotemail.bind(this);
		this.onSubmitforgot = this.onSubmitforgot.bind(this);
        this.state = {
            langKey: ls.get('LangValue'),
            api_url: localStorage.getItem('api_url'),
            forgotemail:'',
            errorMsg: '',
            errors: {},
        };
    }

    onChangeForgotemail(e){
        this.setState({
            forgotemail:e.target.value
        });
    }

    onSubmitforgot(e){
        e.preventDefault();
        let errors = {};
        var forgotemail = new FormData();
        forgotemail.set('email', this.state.forgotemail);
        forgotemail.set('language', this.state.langKey);  
        axios({
            method: 'post',
            url: this.state.api_url+'webforgot',
            data: forgotemail,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const message = res.data.message; 
            errors["forgot"] = message;
            this.setState({
                errors: errors,
                errorMsg:'errorMsg'
            });
            setTimeout(() => {
                this.setState({
                    errors: ''
                });
            }, 2000);	
            if(res.data.status === 'true'){
                this.setState({
                    forgotemail:'',
                });
            }
        })
    }

    render() {
        const { t } = this.props;
        return (
            <div className="">
                <Modal className="modal_div" show={this.props.showModal} onHide={this.props.handleClose} centered>
                    <Form className="" onSubmit={this.onSubmitforgot}>
                        <Modal.Header>
                            <Modal.Title>
                                <Trans i18nKey="forgotpassword">Forgot Password</Trans>
                            </Modal.Title>
                            <Button className="close" onClick={this.props.handleClose}>
                                <img src={close} alt="img" />
                            </Button>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group controlId="formPlaintextEmail" className="forgot_form welcome_form">
                                <Form.Label>
                                    <Trans i18nKey="forgotemail">E-mail</Trans>
                                </Form.Label>
                                <div>
                                    <Form.Control type="email" value={this.state.forgotemail} onChange={this.onChangeForgotemail} placeholder={t("enteryouremail")} required/>
                                </div>
                                <div className={this.state.errorMsg}>{this.state.errors.forgot}</div>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer className="forgot_button_plr">
                            <button className='button_primary'>
                                <Trans i18nKey="forgotreset">Reset</Trans>
                            </button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default withTranslation("translations")(Forgot);
